/**
 * License Acquisition.
 *
 * @group DRM
 *
 * @beta
 */
export const LICENSE_ACQUISITION = 'LicenseAcquisition';
